import React, { useState, useEffect } from "react";
import styled from "styled-components";
import Cookies from "js-cookie";
import { useTranslation } from "react-i18next";
import { Globe } from "../ui/AllImages";


const LangChangeButton = ({...props}) => {
	const { i18n } = useTranslation();
	const [isEnglishSelected, setIsEnglishSelected] = useState(
		Cookies.get("lang") === "en" ? true : false
	);

	const changeLanguageAndDirection = (lng, dir) => {
		i18n.changeLanguage(lng);
		document.documentElement.dir = dir;
		document.body.classList.toggle("rtl", dir === "rtl");
		document.body.classList.toggle("ltr", dir === "ltr");
		Cookies.set("lang", lng, { expires: 60, path: "/" });
		Cookies.set("dir", dir, { expires: 60, path: "/" });
	};

	const handleLanguageChange = () => {
		const newLang = isEnglishSelected ? "ar" : "en";
		const newDir = isEnglishSelected ? "rtl" : "ltr";
		changeLanguageAndDirection(newLang, newDir);
		setIsEnglishSelected(!isEnglishSelected);
	};

	useEffect(() => {
		const savedLang = Cookies.get("lang") || "ar";
		const savedDir = Cookies.get("dir") || "rtl";

		changeLanguageAndDirection(savedLang, savedDir);
	}, []);

	return (
		<ButtonBox onClick={handleLanguageChange} {...props}>
			<span className="change-Btn">
				
				<span className="lang-text">{isEnglishSelected ? "العربية" : "English"}</span>
        <Globe className="icon" alt={isEnglishSelected ? "Arabic" : "USA"} />
			</span>
		</ButtonBox>
	);
};

const ButtonBox = styled.div.withConfig({
  shouldForwardProp: (prop) => !["bg", "border", "color", "iconColor"].includes(prop), // Prevent bg and border from being forwarded
})`
  padding: 0;
  cursor: pointer;
  z-index: 1;

  .change-Btn {
    background: ${({ bg }) => (bg ? bg : "var(--transparent)")};
    border: ${({border}) => (border ? border : "var(--border)")};
    border-radius: 10px;
    color: ${({color}) => (color ? color : "var(--white)" )};
    display: flex;
    align-items: center;
    font-size: 16px;
    height: 40px;
    padding: 0px 15px;
    position: relative;
    text-transform: uppercase;

    svg {
      width: 22px;
      height: auto;
      margin: 0 6px;
      [stroke] {
        stroke: ${({ iconColor }) => (iconColor ? iconColor : "var(--white)")};
      }
      [fill] {
        fill: ${({ iconColor }) => (iconColor ? iconColor : "var(--white)")};
      }
    }

    span {
      padding-bottom: 0;
      font-family: var(--arRegular);
	  body.rtl &{
		font-family: var(--regular);
		padding-top: 3px;
	  }
    }
  }
  .icon {
    cursor: pointer;
    z-index: 1;
  }

  @media (max-width: 500px) {
    .lang-text {
      display: none
    } 
  }
  @media (max-width: 470px) {
    .change-Btn {
      padding: 0 10px!important;
    }
  }
`;

export default LangChangeButton;
